/**
 * @author  : 王冲
 * @desc    : 契约锁
 */

import { request } from "@weapp/utils";
import { publicUrlapi } from "../constants";

//契约锁验证
export const checkQys = (data: any) => {
  const formData = new FormData();
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      formData.append(key, data[key]);
    }
  }
  formData.append('service', window.location.protocol + '//' + window.location.host);
  return request({
    url: window.weappTenantEnv?.passportUrl + publicUrlapi + "/papi/passport/qys/checkAndGetQysUrl",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    method: "POST",
    data: formData
  });
};
//契约锁轮询状态
export const checkQysQrStatus = (data: any) => {
  const formData = new FormData();
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      formData.append(key, data[key]);
    }
  }
  formData.append('service', window.location.protocol + '//' + window.location.host);
  return request({
    url: window.weappTenantEnv?.passportUrl + publicUrlapi + "/papi/passport/qys/qysCheckAccess",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    method: "POST",
    data: formData
  });
};

